import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import { Label } from "@tql/ui-components-react/kendo/labels";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";
import { useAtom } from "jotai";

import type { ShipmentDateRangeOption } from "../../constants/shipment-date-filter.ts";
import { shipmentDateRangeOptions } from "../../constants/shipment-date-filter.ts";
import { shipmentDateRangeAtom } from "../../state/shipment-date-filter-atom.ts";

const FIELD_ID = "shipment-date-range-filter";

export const ShipmentDateFilter = () => {
	const [range, setRange] = useAtom(shipmentDateRangeAtom);

	const selected =
		shipmentDateRangeOptions.find((option) => option.value === range) ??
		shipmentDateRangeOptions[1];

	const handleChange = (event: DropDownListChangeEvent) => {
		const option = event.value as ShipmentDateRangeOption;
		setRange(option.value);
	};

	return (
		<div className={"shipment-date-filter"} id={`${FIELD_ID}-wrapper`}>
			<Label
				className={"k-form-label"}
				editorId={FIELD_ID}
				id={`${FIELD_ID}_label`}
			>
				Show Shipments From Last
			</Label>
			<DropDownList
				ariaLabelledBy={`${FIELD_ID}_label`}
				data={shipmentDateRangeOptions as ShipmentDateRangeOption[]}
				dataItemKey={"value"}
				id={FIELD_ID}
				onChange={handleChange}
				textField={"label"}
				value={selected}
			/>
		</div>
	);
};
